<template>
  <div id='nesting' ref='root'>
  </div>
</template>

<script>
import Nesting from '../assets/javascripts/nesting/nesting';

export default {
  name: 'Nesting',
  components: {},
  nesting: null, // this.$options.nesting

  data () {
    return {};
  },

  mounted () {
    const root = this.$refs.root;
    this.$options.nesting = new Nesting(root);
  },

  beforeDestroy () {
    this.$options.nesting.destroy();
  },

  methods: {
    load (json, bin, nestingData) {
      if (this.$options.nesting.exists()) {
        return this.$options.nesting.reload(json, bin);
      }
      return this.$options.nesting.load(json, bin, 1, nestingData);
    },

    restore (json) {
      this.$options.nesting.restore(json);
    },

    nestByApi (json) {
      this.$options.nesting.nestByApi(json);
    },

    addPart () {
      // console.log(this.$options.nesting.selectedNodes);
      // let newParts = [];
      this.$options.nesting.addParts( this.$options.nesting.selectedNodes );
      console.log('selected nodes: ', this.$options.nesting.selectedNodes);
      // for(let part of this.$options.nesting.selectedNodes){
      //   // console.log(this.$options.nesting.createPart(part.id, part.source));
      //   let newPart = this.$options.nesting.createPart(part.id, part.source);
      //   this.$options.nesting.addPart( newPart, part.position );
      //   newParts.push(newPart);
      // }
      // this.$options.nesting.selectNodes(newParts);  // keep copied parts selected
    },

    removePart () {
      // for(let part of this.$options.nesting.selectedNodes){
      //   this.$options.nesting.removePart( part );
      // }
      this.$options.nesting.removeParts( this.$options.nesting.selectedNodes );
    },

    getParts () {
      return this.$options.nesting.parts;
    },

    add () {
      this.$options.nesting.addNewBin();
    },

    remove () {
      this.$options.nesting.removeLastBin();
    },

    redo () {
      this.$options.nesting.redo();
    },

    undo () {
      this.$options.nesting.undo();
    },

    reset () {
      this.$options.nesting.reset();
    },

    validate () {
      return this.$options.nesting.validate();
    },

    build () {
      return this.$options.nesting.build();
    },

    serialize () {
      return this.$options.nesting.serialize();
    },

    deserialize (source) {
      this.$options.nesting.deserialize(source);
    },

    download () {
      const jsonStr = this.build();
      const name = 'path.json';
      let a = document.createElement('a');
      let e = document.createEvent('MouseEvent');

      a.download = name;

      const url = 'data:text/json;charset=utf-8,' + encodeURIComponent(jsonStr);
      a.href = url;

      e.initEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    }
  }
};

</script>

<style lang="scss" scoped>

#nesting {
  &.panning {
    cursor: move;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Nesting.vue